import React, { useRef, useMemo } from 'react';
import { useFrame } from '@react-three/fiber';
import * as THREE from 'three';

const PARTICLE_COUNT = 1200;
const GRID_SIZE = 20;

function Particles() {
  const pointsRef = useRef(null);

  const positions = useMemo(() => {
    const pos = new Float32Array(PARTICLE_COUNT * 3);
    for (let i = 0; i < PARTICLE_COUNT; i++) {
      pos[i * 3] = (Math.random() - 0.5) * 2 * GRID_SIZE;
      pos[i * 3 + 1] = (Math.random() - 0.5) * 2 * GRID_SIZE;
      pos[i * 3 + 2] = (Math.random() - 0.5) * 2 * GRID_SIZE;
    }
    return pos;
  }, []);

  useFrame((state) => {
    if (!pointsRef.current) return;
    const t = state.clock.elapsedTime * 0.15;
    pointsRef.current.rotation.y = t * 0.05;
    pointsRef.current.rotation.x = Math.sin(t * 0.1) * 0.1;
  });

  return (
    <points ref={pointsRef}>
      <bufferGeometry>
        <bufferAttribute
          attach="attributes-position"
          count={PARTICLE_COUNT}
          array={positions}
          itemSize={3}
        />
      </bufferGeometry>
      <pointsMaterial
        size={0.14}
        color="#00ff88"
        transparent
        opacity={0.8}
        sizeAttenuation
        depthWrite={false}
        blending={THREE.AdditiveBlending}
      />
    </points>
  );
}

export default function Scene() {
  return (
    <>
      <color attach="background" args={['#050508']} />
      <fog attach="fog" args={['#050508', 8, 35]} />
      <ambientLight intensity={0.15} />
      <pointLight position={[10, 10, 10]} color="#00ff88" intensity={1} distance={30} decay={2} />
      <pointLight position={[-10, -5, 5]} color="#0088ff" intensity={0.5} distance={25} decay={2} />
      <Particles />
    </>
  );
}
